"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var get = require('../getValueOfKeyMatching');

function LetterpressSaveTheDates(params) {
  var quantity = parseInt(get(params, /lp_std/), 10);
  var guest_addressing = parseBoolean(get(params, /inv_guestAddressing|REPRINT_lp_inv_guestAddressing/));
  var return_addressing = parseBoolean(get(params, /^lp_inv_returnAddressing|REPRINT_lp_inv_returnAddressing/));
  var smallEnclosureQuantity = parseInt(get(params, /^lp_smallEnclosure|REPRINT_lp_smallEnclosures/i), 10);
  var custom_postage = parseBoolean(get(params, /inv_customPostage/));
  this.letterpressSaveTheDates.add({
    quantity: quantity
  });
  this.saveTheDateEnvelopes.add({
    quantity: quantity,
    guest_addressing: guest_addressing,
    return_addressing: return_addressing,
    custom_postage: custom_postage
  });
  this.personalization.push({
    name: 'Wording',
    value: get(params, /pers_lp_std/)
  });
  this.personalization.push({
    name: 'Return Address',
    value: get(params, /pers_lp_inv_returnAddressing/)
  });

  if (smallEnclosureQuantity) {
    this.letterpressSmallEnclosures.add({
      quantity: smallEnclosureQuantity
    });
    this.personalization.push({
      name: 'Small Enclosures',
      value: get(params, /pers_lp_smallEnclosures/i)
    });
  }

  var has_liner = get(params, /envelope_liner/);

  if (has_liner !== 'None') {
    var liner_pattern = get(params, /liner-pers/);
    var liner_color = get(params, /liner-color/);
    this.envelopeLiners.add({
      liner_pattern: liner_pattern,
      liner_color: liner_color,
      quantity: quantity
    });
  }
}

module.exports = LetterpressSaveTheDates;